/**
 * Erkennung „nach links wischen" = Karte ans Ende der Schlange.
 * Als reine Funktion, damit die Schwellen ohne Touch-Ereignisse prüfbar sind.
 * DESIGN.md lässt keinen fünften Knopf auf dem Lernbildschirm zu; die Geste
 * ersetzt den früheren „Überspringen"-Knopf.
 */
const MIND_WEG = 60 // px — darunter ist es ein Tippen
const MAX_ABWEICHUNG = 0.6 // dy/|dx| — darüber war es Scrollen
const MAX_DAUER = 800 // ms — langsames Ziehen ist kein Wischen

export function istWischenNachLinks({ dx, dy, dauer }) {
  if (dx > -MIND_WEG) return false
  if (dauer > MAX_DAUER) return false
  return Math.abs(dy) / Math.abs(dx) <= MAX_ABWEICHUNG
}
